<icn-dropdown
  class="cs-destination-picker"
  [large]="true"
  [allowMultiple]="false"
  [listDown]="true"
  [textAlign]="'left'"
  [selectedValue]="selectedDestinationId ?? ''"
  (selectedValueChange)="onDropdownChange($event)"
>
  <icn-dropdown-item
    title="All destinations"
    value=""
  ></icn-dropdown-item>
  <ng-template ngFor let-destination [ngForOf]="destinations">
    <icn-dropdown-item
      [value]="destination.id"
      [titleTemplateRef]="destTitle"
    ></icn-dropdown-item>
    <ng-template #destTitle>
      <span class="cs-destination-picker__option-row">
        <span
          class="cs-destination-picker__option-icon-wrap"
          [ngClass]="destination.iconCssClass"
        >
          <span
            [inlineSVG]="destination.icon"
            class="cs-destination-picker__option-icon"
            aria-hidden="true"
          ></span>
        </span>
        <span class="cs-destination-picker__option-name">{{
          destination.name
        }}</span>
      </span>
    </ng-template>
  </ng-template>
</icn-dropdown>
